import * as actionTypes from "./actionTypes";
import {getColor} from "../../shared/blackbook";
import {setQualifyVehicleData} from "./qualifyVehicleQuestions";
import {cloneObject} from "../../shared/utility";

export const getBlackBookColor = (uvc, fullEdit , onNext = null) => {
    return async (dispatch, getState) => {
        const state = getState()
        const  appState = cloneObject(state.app.qualifyVehicle)
        let dataState

        if(fullEdit) {
            dataState = cloneObject(state.fullVehicleEdit)
        } else {
            dataState = cloneObject(state.qualifyVehicle)
        }

        appState.loading = true
        appState.error = false
        //dispatch({data: {qualifyVehicle: appState}, type: actionTypes.SET_APP_DATA})

        dataState.colors = []
        dataState.interiorColors = []

        if (uvc) {
            try {
                const colors = await getColor(uvc)
                dataState.exteriorColors = colors.exterior
                dataState.interiorColors = colors.interior
            } catch (e) {
                appState.error = e
            }
        }

        appState.loading = false
        //dispatch({data: {qualifyVehicle: appState}, type: actionTypes.SET_APP_DATA})
        if(fullEdit) {
            /*dispatch({data: {
                    exteriorColors: dataState.exteriorColors,
                    interiorColors: dataState.interiorColors,
                }, type: actionTypes.SET_FULL_VEHICLE_EDIT})*/

        } else {
            dispatch(setQualifyVehicleData({
                exteriorColors: dataState.exteriorColors,
                interiorColors: dataState.interiorColors,
            }))
        }
    };
};